import { render, staticRenderFns } from "./Tester.vue?vue&type=template&id=447728f4&scoped=true&"
import script from "./Tester.vue?vue&type=script&lang=js&"
export * from "./Tester.vue?vue&type=script&lang=js&"
import style0 from "./Tester.vue?vue&type=style&index=0&id=447728f4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "447728f4",
  null
  
)

export default component.exports